
import Vue from "vue";
import GlobalSnackbar from "@/components/GlobalSnackbar.vue";
import AuthLoadingCard from "@/components/AuthLoadingCard.vue";
import AuthLoggedOutCard from "@/components/AuthLoggedOutCard.vue";
import PgFeeSettingsModal from "@/components/PgFeeSettingsModal.vue";
import OnboardingModal from "@/components/OnboardingModal.vue";
import OperationalLoadingDialog from "@/components/OperationalLoadingDialog.vue";
import { APP_TITLE } from "@/constants/app";
import eventBus from "@/eventBus";

export default Vue.extend({
  components: {
    GlobalSnackbar,
    AuthLoadingCard,
    AuthLoggedOutCard,
    PgFeeSettingsModal,
    OnboardingModal,
    OperationalLoadingDialog,
  },
  data() {
    return {
      appTitle: APP_TITLE,
    };
  },
  computed: {
    signing() {
      return this.$store.state.signing;
    },
    authChecked() {
      return this.$store.state.authChecked;
    },
    shopName() {
      return this.$store.state.shop.shop_name;
    },
    isLogin() {
      return this.$store.getters.isAuthenticated;
    },
    shopInitializationFailed() {
      return this.$store.state.shopProfileStatus === "error";
    },
    showInitializationStatus() {
      return (
        !this.$store.state.operationalReady &&
        this.$store.state.shopProfileStatus !== "idle"
      );
    },
  },
  methods: {
    openChat() {
      window.open(
        "https://open.kakao.com/o/sacPVhGg",
        "_blank",
        "noopener,noreferrer"
      );
    },
    openPgFeeSettings(
      unconfiguredItems?: any,
      targetTab?: string,
      presentationMode?: string
    ) {
      const tab =
        targetTab ||
        (Array.isArray(unconfiguredItems) && unconfiguredItems.length > 0
          ? "unconfigured"
          : "matrix");
      const target = `/settings/pg-fee/${tab}`;
      if (this.$route.path !== target) {
        this.$router.push(target).catch((err) => err);
      }
      (this.$refs.pgFeeSettingsModal as any)?.open(
        unconfiguredItems,
        targetTab,
        presentationMode
      );
    },
    handlePgFeeClose() {
      if (this.$route.path.startsWith("/settings/pg-fee")) {
        const month = (this.$route.params as any)?.month;
        this.$router
          .push(month ? `/calendar/${month}` : "/")
          .catch((err) => err);
      }
    },
    handlePgFeeTabChange(tab: string) {
      const target = `/settings/pg-fee/${tab}`;
      if (
        this.$route.path !== target &&
        this.$route.path.startsWith("/settings/pg-fee")
      ) {
        this.$router.replace(target).catch((err) => err);
      }
    },
    openOnboarding(step?: number) {
      if (this.$route.path !== "/guide") {
        this.$router.push("/guide").catch((err) => err);
      }
      (this.$refs.onboardingModal as any)?.open(step);
    },
    handleOnboardingClose() {
      if (this.$route.path.startsWith("/guide")) {
        this.$router.push("/").catch((err) => err);
      }
    },
    openSavedResultList() {
      eventBus.$emit("open-saved-result-list");
    },
    removeQuery() {
      const currentUrl = new URL(window.location.href);
      const searchParams = new URLSearchParams(currentUrl.search);
      searchParams.delete("a");
      searchParams.delete("r");
      currentUrl.search = searchParams.toString();
      window.history.replaceState({}, "", currentUrl.toString());
    },
    async signIn() {
      const urlParams = new URLSearchParams(window.location.search);
      const access_token = urlParams.get("a");
      const refresh_token = urlParams.get("r");

      if (access_token && refresh_token) {
        await this.$store.dispatch("startNewSession", {
          access_token,
          refresh_token,
        });
        this.removeQuery();
      } else if (
        !this.$store.state.access_token &&
        !this.$store.state.refresh_token
      ) {
        this.$store.commit("setAuthChecked", true);
        return;
      } else {
        this.$store.commit("setSigning", !this.$store.state.mall_info);
      }

      let mallInfo = this.$store.state.mall_info;
      if (!mallInfo) {
        mallInfo = await this.$store.dispatch("verifyIdentity");
      }

      if (!mallInfo) {
        if (this.$store.state.authError !== "recovery-pending") {
          await this.$store.dispatch("invalidateSession", "session-expired");
        } else {
          this.$store.commit("setSigning", false);
          this.$store.commit("setAuthChecked", true);
        }
        return;
      }

      this.$store.commit("setSigning", false);
      this.$store.commit("setAuthChecked", true);
      void this.$store.dispatch("initializeOperationalContext");
    },
    async signOut() {
      await this.$store.dispatch("signOut");
      this.removeQuery();
    },
    retryInitialization() {
      void this.$store.dispatch("retryOperationalContext");
    },
    retryAuthentication() {
      this.$store.commit("setSigning", true);
      void this.signIn();
    },
  },
  created() {
    document.title = this.appTitle;
    this.signIn();
    eventBus.$on("open-pg-fee-settings", this.openPgFeeSettings);
    eventBus.$on("open-onboarding", this.openOnboarding);
  },
  beforeDestroy() {
    eventBus.$off("open-pg-fee-settings", this.openPgFeeSettings);
    eventBus.$off("open-onboarding", this.openOnboarding);
  },
});
